import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import userTypesServices from '@src/services/userTypes.services';

export const getUserTypesList = createAsyncThunk(
  'getUserTypesList',
  async (body, { rejectWithValue }) => {
    try {
      return await userTypesServices.userTypesgetList();
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  userTypeList: [],
};

export const userTypesSlice = createSlice({
  name: 'userTypes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUserTypesList.fulfilled, (state, action) => {
      state.userTypeList = action?.payload?.data?.items;
    });
  },
});
